var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGmaps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1c9957",
    d: "M42 39V9a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v30a3 3 0 0 0 3 3h30a3 3 0 0 0 3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3e7bf1",
    d: "M9 42h30c1.657 0-15-16-15-16S7.343 42 9 42z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbccc9",
    d: "M42 39V9c0-1.657-16 15-16 15s16 16.657 16 15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#efefef",
    d: "M39 42a3 3 0 0 0 3-3v-.245L26.245 23 23 26.245 38.755 42H39z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd73d",
    d: "M42 9a3 3 0 0 0-3-3h-.245L6 38.755V39a3 3 0 0 0 3 3h.245L42 9.245V9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d73f35",
    d: "M36 2c-5.523 0-10 4.477-10 10 0 6.813 7.666 9.295 9.333 19.851.107.68.115 1.149.667 1.149s.56-.469.667-1.149C38.334 21.295 46 18.813 46 12c0-5.523-4.477-10-10-10z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#752622",
    d: "M36 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 1 0 0-7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.493 12.531v2.101h2.994c-.392 1.274-1.455 2.185-2.994 2.185a3.317 3.317 0 1 1 2.156-5.837l1.548-1.547A5.5 5.5 0 1 0 14.493 19c4.81 0 5.637-4.317 5.184-6.461l-5.184-.008z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmaps);
export default __webpack_public_path__ + "static/media/gmaps.0b263a69ae82fd5714d2ba891f1f906c.svg";
export { ForwardRef as ReactComponent };